import clsx from 'clsx';
import React, { useState } from 'react';

const ProductSpecification = (specifications) => {
    return (
        <>
            <table className={'table-fixed border-collapse w-full'}>
                <tbody className={'w-full [&>tr:nth-child(odd)]:bg-gray-50 [&>tr:nth-child(even)]:bg-gray-100'}>

                    {specifications.productFields.map(element => (
                        <tr className={'w-full'} key={element.id}>
                            <td className={'p-2 border border-slate-300'}>{element.name}</td>
                            <td className={'p-2 border border-slate-300'}>{element.value}</td>
                        </tr>
                    ))}

                </tbody>
            </table>
        </>
    );
};

export default ProductSpecification;
